import{createContext}from'react';export var focusScope=/*#__PURE__*/createContext(undefined);